import { PageContentLayout } from '@/creditflowresearch/ui/common/components/ContentLayouts';
import withApplicationPropsV2 from '@/creditflowresearch/application/withApplicationPropsV2';
import ArticleContextProvider from '@/creditflowresearch/application/ArticlesAndStats/Article';
import Article from '@/creditflowresearch/ui/components/creditFlow/Article';
import getServerSideArticle from '@/creditflowresearch/application/ArticlesAndStats/Article/serverSide/getServerSideArticle';
import { IArticleWithMappedData } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Article';
import { pageNotFound } from '@framework/router/Next/helpers';
import getServerSideArticleBreadcrumbs from '@/creditflowresearch/application/Breadcrumbs/serverSide/getServerSideArticleBreadcrumbs';

export const getServerSideProps = withApplicationPropsV2(async (context) => {
  const article = await getServerSideArticle(context);
  if ('notFound' in article) {
    return pageNotFound();
  }
  const breadcrumbs = getServerSideArticleBreadcrumbs(context, article.headline);

  return ({
    props: {
      article,
      breadcrumbs,
    },
  });
}, { needsLegacyDictionaries: false });

export default ({ article }: { article: IArticleWithMappedData }) => (
  <ArticleContextProvider article={ article }>
    <PageContentLayout>
      <Article />
    </PageContentLayout>
  </ArticleContextProvider>
);
